import { Alert } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export const PageErrorCentered = ({ message }: { message: string }) => {
	const { t } = useTranslation()
	return (
		<Alert.Root status='error'>
			<Alert.Indicator />
			<Alert.Content>
				<Alert.Title>{t('error_fetching_data_title')}</Alert.Title>
				<Alert.Description>{message}</Alert.Description>
			</Alert.Content>
		</Alert.Root>
	)
}
